import * as React from 'react';
import * as styles from './Notice.css';
import { ContentLayout } from '../ContentLayout';
import { ArticleParagraph2, IconFunctionalWarningSign24, UIHeading4 } from '@cian/ui-kit';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var Notice = function Notice(_ref) {
  var title = _ref.title,
    text = _ref.text;
  return /*#__PURE__*/_jsx("div", {
    className: styles['notice-wrapper'],
    children: /*#__PURE__*/_jsx(ContentLayout, {
      children: /*#__PURE__*/_jsxs("div", {
        className: styles['notice-content'],
        children: [/*#__PURE__*/_jsx(IconFunctionalWarningSign24, {
          color: "icon-warning-default"
        }), /*#__PURE__*/_jsxs("div", {
          className: styles['notice'],
          children: [title && /*#__PURE__*/_jsx(UIHeading4, {
            children: title
          }), /*#__PURE__*/_jsx(ArticleParagraph2, {
            children: text
          })]
        })]
      })
    })
  });
};